// extracted by mini-css-extract-plugin
export var brand = "_bp-9";
export var compact = "_bp-6";
export var extraSmall = "_bp-7";
export var icon = "_bp-0";
export var large = "_bp-4";
export var light = "_bp-1";
export var medium = "_bp-5";
export var outline = "_bp-b";
export var primaryDark = "_bp-a";
export var primaryLight = "_bp-8";
export var primaryModern = "_bp-c";
export var success = "_bp-2";
export var successSolid = "_bp-3";